// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2izVv","importantInfo":"styles_importantInfo__1I8Yz"};